import { RootState } from "@/reducers";
import { socket } from "@/shared/config/socket";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "@/store";
import TheContentWeb from "./TheContentWeb";
import { getProfile } from "../auth/auth.api";
import { logout } from "../auth/auth.reducer";

const TheLayoutWeb = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { user } = useSelector((state: RootState) => state.authentication);

  useEffect(() => {
    socket.on("connect", () => {
      console.log("Connected to server");
    });
    socket.on(`user_${user?.id}_new_change_money`, (res: any) => {
      dispatch(getProfile());
    });

    socket.on(`user_${user?.id}_change_status`, (res: any) => {
      if (res?.status == "INACTIVE") {
        dispatch(logout());
      }
    });

    return () => {
      socket.off(`user_${user?.id}_new_change_money`);
      socket.off(`user_${user?.id}_change_status`);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id]);

  return (
    <div>
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        <div className="body flex-grow-1">
          <TheContentWeb />
        </div>
      </div>
    </div>
  );
};
export default TheLayoutWeb;
